import type { Dictionary } from 'lodash';
import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { GetShareLinkResponse } from '@backend/src/endpoints/leadGetShareLink';
import { useAppSelector } from 'store/configureStore';
import { getShareLink } from 'services/backend';

export type useLeadShareLink = UseQueryResult<GetShareLinkResponse>;

const useLeadShareLink = (): useLeadShareLink => {
  const activeLeadID = useAppSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state) => (state as Dictionary<any>).app?.activeLeadID,
  );

  return useQuery({
    queryKey: ['shareLink', activeLeadID],
    queryFn: async () => getShareLink({ activeLeadID }),
    enabled: Boolean(activeLeadID),
    refetchOnWindowFocus: false,
    staleTime: 60000 * 14, // 14 minutes. Creds and cookie are valid for 15 minutes.
    refetchInterval: 60000 * 14, // 14 minutes. Creds and cookie are valid for 15 minutes.
  });
};

export default useLeadShareLink;
